import { render, staticRenderFns } from "./Postal.vue?vue&type=template&id=4a8f94a5&scoped=true"
import script from "./Postal.vue?vue&type=script&lang=js"
export * from "./Postal.vue?vue&type=script&lang=js"
import style0 from "./Postal.vue?vue&type=style&index=0&id=4a8f94a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8f94a5",
  null
  
)

export default component.exports